import React from "react";
import styled from "styled-components";

import { Box, Text } from "grommet";

import Logo from "content/logo.svg";

const StyledBox = styled(Box)`
  max-width: 100%;
  min-height: 175px;
`;

function SectionBreak() {
  return (
    <StyledBox justify="start" align="center" pad={{ top: "small" }}>
      <img alt="TRADOC Logo" width={24} height={24} src={Logo} />
      <Text color="dark-6">Supplement</Text>
    </StyledBox>
  );
}

export default SectionBreak;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/SectionBreak.js